module.exports = __webpack_public_path__ + "img/logo.fde6143c.png";